import { HeaderClassParams } from "@ag-grid-community/core";
import clsx from "clsx";
import { GenericTableRow } from "gen/model/genericTableRow";
import { isFunction, last } from "lodash-es";
import {
  getAgColumnParents,
  getAgGridPrimaryHeaderRowCount,
  isLastVisibleColumn,
} from "shared/components/table/ag/AgGridUtils";
import { DataTableContext } from "shared/components/table/data/DataTableContext";
import { buildDataTableColumnContext } from "shared/components/table/data/internal/DataTableContextBuilders";
import { isGenericTableColumn } from "shared/components/table/data/internal/DataTableInternalUtils";
import { isMaybernTableColumnLastInGroup } from "shared/components/table/maybern/MaybernTableUtils";

export const dataTableHeaderClass = (
  params: HeaderClassParams<GenericTableRow>,
) => {
  if (params.columnGroup) {
    return clsx({
      "mb-header-has-title": Boolean(params.colDef.headerName),
      "mb-header-row-not-last":
        getAgGridPrimaryHeaderRowCount(params.api) > 2 &&
        params.columnGroup.getProvidedColumnGroup().getLevel() === 0,
    }).split(" ");
  }
  if (!params.column) {
    return undefined;
  }
  const tableContext: DataTableContext = params.context;

  const columnContext = isGenericTableColumn(params.column)
    ? buildDataTableColumnContext(tableContext, params.column)
    : undefined;

  const parentAgCols = getAgColumnParents(params.column);

  return clsx(
    isFunction(tableContext.headerClass)
      ? tableContext.headerClass(params)
      : tableContext.headerClass,
    tableContext.headerOrCellClass?.(params),
    [
      {
        "mb-column-has-form-field": columnContext?.inferredData?.hasFormField,
        "mb-header-last-in-group": isMaybernTableColumnLastInGroup(params),
        "mb-header-has-title": Boolean(params.colDef.headerName),
        "mb-header-parent-is-placeholder": parentAgCols.every(
          (c) => !c.getColGroupDef()?.headerName,
        ),
        "mb-header-parent-no-title":
          !last(parentAgCols)?.getColGroupDef()?.headerName,
        [`mb-header-value-type-${columnContext?.inferredData?.valueType}`]:
          !!columnContext?.inferredData?.valueType,
        "mb-cell-is-last-visible-column": isLastVisibleColumn(
          params.api,
          params.column,
        ),
      },
    ],
  ).split(" ");
};
